module.exports = __webpack_public_path__ + "img/cisco.f24673db.svg";